export default __webpack_public_path__ + "static/media/smoke.19ccac52.mp4";